var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.geoLocation)?_c('GmapMap',{staticStyle:{"width":"100%","height":"300px"},attrs:{"center":_vm.geoLocation,"zoom":17,"map-type-id":"roadmap"}},[_c('GmapMarker',{attrs:{"position":_vm.geoLocation}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }